<template lang="html">
  <div class="startup_page" id="content" v-if="startup ">
    <ConnectedSoonModal v-if="startup.linkplus" :dialogVisible="showSoonModal" :sid="startup._id.$oid" @close="showSoonModal = false;" :client_name="partner_client_name" :who="startup.name" @confirmed="data_policy_start" />

    <div class="" v-if="startup.company_type">
      <ProfileStartupEditor :showGlobal="showGlobal"  :initialStartup="startup" v-if='startup.company_type.value.toUpperCase() == "STARTUP"' />
      <ProfileNonStartupEditor :showGlobal="showGlobal"  :initialStartup="startup" v-else />

    </div>
  </div>
</template>

<script>
// import StartupInfoLine from '@/components/InfoStartupLine.vue'
// import { nextTick } from 'vue';
import { toast } from 'vue-sonner'
import _ from 'lodash';
// import countries from '@/assets/db_coutries.json';
import ProfileStartupEditor from '@/views/ProfileStartupEditor.vue';
import ProfileNonStartupEditor from '@/views/ProfileNonStartupEditor.vue';
import ConnectedSoonModal from '@/components/modals/ConnectedSoonModal.vue'
export default {
  name : "StartupInfo",
  components: {
    ProfileStartupEditor,
    ProfileNonStartupEditor,
    ConnectedSoonModal
  },

  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      pageInfo: {
        mainTitle : "Your innovator profile ",
        subTitle : "",
      },
      errors:false,
      submitOK: false,
      partner_client_name: null,
      showSoonModal: false,
      what :'',
      dialog: {
        summary_update: false,
      },
      bindProps: {
        mode: "international",
        defaultCountry: "FR",
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: "Enter a phone number",
        required: false,
        enabledCountryCode: true,
        enabledFlags: true,
        preferredCountries: ["FR", "CH","US",'ES',"IT","GB",'NL'],
        wrapperClasses: "",
      },
      showGlobal:false,
      startup : {
        startup_datapolicy_ok: false,
        revenue: {
          unit:null,
          currency: null,
          value:null,
        },
        investment_raised: {
          unit:null,
          currency: null,
          value:null,
        },
        targeted_segements: [],
        partnership_objectives: [],
      }
    }
  },
  methods:{
    data_policy_start(){
      this.showSoonModal = false;
        //this.showEditModal('global');
        this.showGlobal = true;
    },
    showEditModal(modal){
      if(modal == "summary"){
        this.what = "summary";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }

      else if(modal == "contact"){
        this.what = "contact";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      else if(modal == "global"){
        this.what = "global";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      else if(modal == "needhelp"){
        this.what = "needhelp";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      else if(modal == "solution"){
        this.what = "solution";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      else if(modal == "capabilities"){
        this.what = "capabilities";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      else if(modal == "contacts"){
        this.what = "contacts";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      else if(modal == "goals"){
        this.what = "goals";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      else if(modal == "traction"){
        this.what = "traction";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      else if(modal == "company"){
        this.what = "company";
        this.to_edit_startup = Object.assign({}, this.startup);
        this.backup_startup = Object.assign({}, this.startup);
        this.dialog.summary_update = true;
      }
      console.log(this.backup_startup);
    },

    closeAndReset(){
      this.dialog.summary_update = false;
      this.startup = this.backup_startup;
    },
    gobackrouter : function(){
      this.$router.go(-1);
    },
  },
  mounted(){
    this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)

    this.axios.get(process.env.VUE_APP_API_URL+"/startup_for_startup/"+this.$route.params.sid).then( (r) => {
        var temp = _.merge(this.startup, r.data)
        this.startup = temp;
        if(!this.startup.investment_raised)this.startup.investment_raised = {
          value : 0,
          unit:null,
          currency: null
        }
        if(!this.startup.market_potential)this.startup.market_potential = {
          value : 0,
          unit: null,
          currency: null
        }
        if(!this.startup.last_funding_round)this.startup.last_funding_round = {
          value : 0,
          unit: null,
          currency: null
        }

        if(!this.startup.revenue)this.startup.revenue = {
          value : 0,
          unit: null,
          currency: null
        }
        if(!this.startup.growth)this.startup.growth = {
          m12 : null,
          m6: null,
          m3: null
        }
        if(!this.startup.location)this.startup.location = [];

        //partner_logo
        if(this.startup.partial == true && !this.startup.data_policy){
          if(this.startup.linkplus){
            var lpid = this.startup.linkplus[this.startup.linkplus.length - 1];
            if(lpid){
              this.axios.get(process.env.VUE_APP_API_URL+"/linkplus_partner/"+lpid.$oid).then( (r) => {
                this.partner_client_name = r.data;
                this.showSoonModal= true;
              });

            }

          }

        }
        else if (this.startup.partial == true){
          this.data_policy_start();
        }
      }).catch( (e) => {
        console.log(e);
      if(e.response.status == 403)toast.error("You are not authorized to see this ressource");
      else toast.error("Oops! Something went wrong")
    });
},

}
</script>

<style lang="css" scoped>
.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  padding-bottom:20px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-bottom-left-radius: 8px;
border-bottom-right-radius: 8px;
position:relative;
}

</style>
<style media="screen">
  .v-window{
    border: 1px solid #3783C5;
    margin-bottom:50px;
  }
  .v-tabs{
        background: #115AA4 !important;

  }
  .v-tab--selected{
    background: #3783C5 !important;
  }
  .v-tab__slider{
    display:none;
  }
  .vue-treeselect__menu{
    height:150px !important;
  }
</style>
